import { formatDisk as formatDiskApi, autoPartition as autoPartitionApi } from '@remote/api/adapter/disk-mqtt'
import { poll2queryJob } from '@remote/api/adapter/helper/get-job'
import global from '@remote/store/constantStore'
import { store } from '@remote/store'
import { getDisksApi } from '@remote/store/hezi-file/disk'
import { IDiskPartitionItem } from '@remote/type/hezi'
import { promisifyDialog } from '@shared/utils/dialog'
import AddNetDriveForm from './components/AddNetDriveForm.vue'
import BackupRestoreDialog from './components/BackupRestoreDialog.vue'
import BackupRestoreResultDialog from './components/BackupRestoreResultDialog.vue'

export function autoPartition (disk: IDiskPartitionItem): Promise<any> {
  const findTargetDisk = item => item.name === disk.name
  const delay = () => new Promise(r => setTimeout(r, 3000))
  const handleQueryDisks = async () => {
    await delay()
    return getDisksApi()
      .then(response => {
        const [err, res] = response
        if (!err && res?.list?.length) {
          const targetDisk = res?.list?.find(findTargetDisk)
          if (targetDisk?.partitions) {
            const [part] = targetDisk?.partitions
            return formatDisk(part)
          }
        } else {
          return Promise.reject('磁盘分区失败')
        }
      })
  }
  return autoPartitionApi({ disk_id: disk.name })
    .then(res => {
      if (res?.result?.list) {
        const targetDisk = res?.result?.list?.find(findTargetDisk)
        if (targetDisk) {
          const [part] = targetDisk.partitions
          return formatDisk(part)
        }
      } else {
        return handleQueryDisks()
      }
    })
}

export function formatDisk (disk: IDiskPartitionItem): Promise<any> {
  const GB = 1024 * 1024 * 1024
  const limit = 200 * GB
  const fmtType = (disk.size >= limit ? 'ext4' : 'exfat')
  const param = {
    disk_id: disk.id,
    format_type: fmtType,
    correlation_id: 'hezi_web_pc',
    force: true,
  }
  if (!disk.uuid && !disk.id) {
    return autoPartition(disk)
  }
  return formatDiskApi(param)
  // @ts-ignore
    .then(res => {
      if (res.ret === 0) {
        if (!res.result) return Promise.resolve()
        const deviceId = global.fromSpace
        const { job_id, formatting } = res.result
        if (!formatting || !job_id) return Promise.resolve()
        return poll2queryJob({
          device_id: deviceId,
          userid: store.state?.user?.userID,
          biz: 'format_partition',
          jobIds: [job_id],
          options: {
            timeout: 0,
            interval: 3 * 1000,
            leading: true,
            onCheck: (jobs) => {
              const [job] = jobs
              return ['', [1, 5].includes(job.status)]
            },
          },
        }, {
          method: 'POST',
          apiEnv: 'heziProduction',
          headers: { Target: deviceId },
        })
      } else {
        return Promise.reject(res.msg)
      }
    })
}

export const openAddNetDriveForm = (props: PromisifyDialogProps<typeof AddNetDriveForm>) => {
  return promisifyDialog(AddNetDriveForm, props)
}

export function openBackupRestoreDialog (props: PromisifyDialogProps<typeof BackupRestoreDialog>) {
  return promisifyDialog(BackupRestoreDialog, props)
}

export function openBackupRestoreResultDialog (props: PromisifyDialogProps<typeof BackupRestoreResultDialog>) {
  return promisifyDialog(BackupRestoreResultDialog, props)
}